import React, { useState } from 'react'

import HealthSherpaForAgentLogo from '@components/branding/healthsherpa-for-agents-logo'
import { Box, Link, Icon, Paper, Stack, Text } from '@components/ui'
import CONTACTS from '@constants/contacts'
import PATHS from '@constants/paths'
import URLS from '@constants/urls'
import Configuration from '@utils/configuration'

import useAuth from '../../hooks/use-auth'

import onToggle from './language-toggle'

const Header = () => {
  const { user } = useAuth()
  const [currLang, setCurrLang] = useState(Localize?.getLanguage() === 'en' ? 'Spanish' : 'English')

  const { spanishSupported } = Configuration

  const onLanguageToggle = (e) => {
    e.preventDefault()
    onToggle(setCurrLang, user)
  }

  return (
    <Paper component="header" elevation={2} square>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        padding={2}
        spacing={{ xs: 1, sm: 3 }}
        alignItems="center"
      >
        <Box flex={1}>
          <Link.Internal to={PATHS.trainings.index}>
            <HealthSherpaForAgentLogo />
          </Link.Internal>
        </Box>
        <Box whiteSpace="nowrap">
          <Link.Internal to={PATHS.profile} variant="avenir14">
            My Profile
          </Link.Internal>
        </Box>
        <Box whiteSpace="nowrap">
          <Link href={URLS.faq} target="_blank" variant="avenir14" rel="noreferrer">
            FAQ
          </Link>
        </Box>
        <Box whiteSpace="nowrap">
          <Link href={PATHS.logout} variant="avenir14">
            Log Out
          </Link>
        </Box>
        <Box whiteSpace="nowrap">
          <Link href={URLS.returnToCms} variant="avenir14">
            Return to Enterprise Portal
            <Icon name="new-window" size="sm" />
          </Link>
        </Box>
        <Box whiteSpace="nowrap">
          <Text variant="avenir14">Questions? Call {CONTACTS.supportPhone}</Text>
        </Box>
        {spanishSupported && (
          <Box whiteSpace="nowrap">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link
              variant="avenir14"
              href=""
              onClick={onLanguageToggle}
              data-layer="language_selection"
            >
              {currLang}
            </Link>
          </Box>
        )}
      </Stack>
    </Paper>
  )
}

export default Header
